import api from "../../../../service/api";
import routes from "../../../../service/apiRoutes";

export const topReports = () => api.get(routes.topReports)
export const clients = () => api.get(routes.listClients)